import { makeStyles } from "@material-ui/core";
import IconButton from "@material-ui/core/IconButton";
import DoubleArrowIcon from "@material-ui/icons/DoubleArrow";
import * as React from "react";

interface UpdateButtonListViewProps {
  disableAction: boolean;
  onClickButton: () => void;
}

const useStyles = makeStyles(
  () => ({
    iconButton: {
      "&:hover": {
        color: "#757575"
      },
      background: "#0030FF",
      color: "white",
      marginLeft: "5px",
      width: "33px !important"
    }
  }),
  { name: "UpdateButtonListView" }
);

const UpdateButtonListView: React.FC<UpdateButtonListViewProps> = props => {
  const classes = useStyles(props);
  const { disableAction, onClickButton } = props;
  return (
    <IconButton
      disabled={disableAction}
      onClick={event => {
        onClickButton();
        event.stopPropagation();
      }}
      className={classes.iconButton}
      size="small"
    >
      <DoubleArrowIcon />
    </IconButton>
  );
};

export default UpdateButtonListView;
